// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__VlExQ","inputWrap":"Table_inputWrap__3PFi2","col":"Table_col__1jRJQ","bmiTooltip":"Table_bmiTooltip__1u4rl"};